module.exports = __webpack_public_path__ + "img/colored-square.2679dcde.svg";